import React from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import './NavBar.css'; // Import the custom CSS file
import audioWaveLogo from '../assets/audio-wave.png'; // Import the audio wave logo
import { Link } from 'react-router-dom';

const NavBar = () => {
  return (
    <Navbar expand="lg" className="custom-navbar">
      <Navbar.Brand as={Link} to="/" className="navbar-brand">
       ANUSHKA RATH <img src={audioWaveLogo} alt="Audio Wave Logo" className="audio-wave-logo" /> VOICEOVERS
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="nav-links">
          <Nav.Link as={Link} to="/" className="nav-link">HOME</Nav.Link>
          <Nav.Link as={Link} to="/voice-details" className="nav-link">VOICE DETAILS</Nav.Link>
          <Nav.Link as={Link} to="/demos" className="nav-link">MORE DEMOS</Nav.Link>
          <Nav.Link as={Link} to="/contact" className="nav-link">CONTACT</Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavBar;
